const DEFAULT_LD_CLIENT_SIDE_ID = '6096f35fceeceb0de5e990c7';

export function getLaunchDarklyClientSideId() {
	return process.env.REACT_APP_LD_CLIENTSIDEID || DEFAULT_LD_CLIENT_SIDE_ID;
}

export default getLaunchDarklyClientSideId;
